import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {Icon} from 'react-fa'

import { setForm } from '../actions/formulaire'

class InputText extends Component {

  constructor(props){
    super(props);
    this.state = {
      value : 0,
      style : '',
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.reset){
      this.setState({style : '', value : 0})
    }
  }

  toggle(){
    if(this.state.style === "active"){
      this.setState({style : ''})
    }else{
      this.setState({style : 'active'})
    }
  }

  selectNumber(e){
    this.props.setForm({"person" : e.target.id})
    this.setState({value : parseInt(e.target.id),style : ''})
  }

  render() {
    const error = this.props.error
    var items = 5;
    var elts = []
    for(var i = 0; i < items; i++ ){
      let style = ""
      let num = i
      if(i === this.state.value){
        style = "selected"
      }

      elts.push(<span id={i} className={style} onClick={this.selectNumber.bind(this)} key={i}>{i}</span>)
    }

    return (
      <div className="inputNumber">
        <p>Je viens avec
        <span className="containerNumber">
          <span className={"select "+this.state.style}>
            <span >{this.state.value}</span>
            {elts}
          </span>
        </span>

        <Icon className="chevron" name="chevron-down" onClick={this.toggle.bind(this)}/>
          personnes
        </p>
      </div>
    )
  }

}
function mapDispatchToProps(dispatch){
  return bindActionCreators({
    setForm : setForm
  },dispatch)
}

function mapStateToProps(state) {
  return {
    reset : state.reset
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InputText);



// WEBPACK FOOTER //
// ./src/client/components/inputNumber.js